import { render, staticRenderFns } from "./loginType.vue?vue&type=template&id=0c31e38c&scoped=true&"
import script from "./loginType.vue?vue&type=script&lang=js&"
export * from "./loginType.vue?vue&type=script&lang=js&"
import style0 from "./loginType.vue?vue&type=style&index=0&id=0c31e38c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31e38c",
  null
  
)

export default component.exports